// extracted by mini-css-extract-plugin
export default {"link":"Hyperlink_link__l3Xjb"};